import React from 'react'
import { FormattedMessage } from 'react-intl'

export const loadingMsg = (<FormattedMessage
  id="Loading.loading"
  description="Message that tells user that Rome2Rio is loading tickets"
  defaultMessage="Searching for tickets"
/>)
